var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElasticpath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.917 71.5173C94.3682 87.7241 94.553 106.061 88.1019 122.267L138.576 122.115V71.5334L87.917 71.5173Z",
    fill: "#2BCC7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9171 71.5178L123.728 35.7669L87.8785 0L56 31.8056L72.6775 48.445C79.4872 55.239 84.5705 63.1226 87.9171 71.5178Z",
    fill: "#2BCC7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6775 145.205L56 161.844L87.8785 193.649L123.728 157.882L88.102 122.268C84.7554 130.662 79.4872 138.41 72.6775 145.205Z",
    fill: "#2BCC7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElasticpath);
export default __webpack_public_path__ + "static/media/icon-elasticpath.33d4020793a3aaed0a27eae8b29fdcdf.svg";
export { ForwardRef as ReactComponent };